import { Button, Flex, Link, Text } from '@dodilio/ui-design-lib';
import type { Who } from '../session';

export const Avatar = ({ who, size = 40 }: { who: Who; size?: number }) => (
    <span
        aria-hidden
        style={{
            width: size, height: size, borderRadius: 999, flexShrink: 0,
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            background: 'var(--accent-a3)', color: 'var(--accent-11)',
            fontWeight: 600, fontSize: size * 0.42,
        }}
    >
        {(who.name || who.email || '?').trim().charAt(0).toUpperCase()}
    </span>
);

/**
 * Before signup does anything for a session it didn't start: who this is, and
 * a way out if it isn't them. Shown once per flow.
 */
export const ContinueAs = ({ who, onContinue, onSomeoneElse, busy }: {
    who: Who;
    onContinue: () => void;
    onSomeoneElse: () => void;
    busy?: boolean;
}) => (
    <Flex direction="column" gap="4">
        <Flex align="center" gap="3" p="3" style={{ border: '1px solid var(--gray-a4)', borderRadius: 12, background: 'var(--color-panel-solid)' }}>
            <Avatar who={who} />
            <Flex direction="column" style={{ minWidth: 0 }}>
                <Text size="2" weight="medium" truncate>{who.email || who.name || 'Your Dodil account'}</Text>
                <Text size="1" color="gray">{who.provider === 'google' ? 'Signed in with Google' : 'Signed in to Dodil'}</Text>
            </Flex>
        </Flex>
        <Button radius="full" size="3" onClick={onContinue} loading={busy} disabled={busy}>
            Continue{who.email ? ` as ${who.email}` : ''}
        </Button>
        <Text size="2" color="gray" align="center">
            Not you?{' '}
            <Link href="#" underline="always" onClick={(e: React.MouseEvent) => { e.preventDefault(); onSomeoneElse(); }}>Use another account</Link>
        </Text>
    </Flex>
);
